import { render, staticRenderFns } from "./RaceRecordings.vue?vue&type=template&id=b6dd92a6"
import script from "./RaceRecordings.vue?vue&type=script&lang=js"
export * from "./RaceRecordings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports